export default __webpack_public_path__ + "static/media/portfolio.84d3b955.gif";